import React, { useState } from "react";
import { Popover } from "antd";
import moment from "moment";
export default function ProjectCard({
  individualProject,
  setProjectId,
  setProject,
  setProjectStatus,
  setUpdatedProject,
  setActive,
  varient,
}) {
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <div
      onClick={() => {
        setProjectId(individualProject?.id)
        setUpdatedProject({
          id: individualProject?.id,
          name: individualProject?.title,
          description: individualProject?.description,
          accessLevel: individualProject?.access_level,
        });
      }}
      className="flex-1 shadow-sm shadow-gray-400 p-4 cursor-pointer rounded-md bg-white w-full"
    >
      <div className="flex flex-row justify-between items-center">
        <span className="flex flex-row space-x-2">
          <span className="h-12 p-4 bg-[#2EBAA3] text-white flex justify-center items-center rounded-lg">
            {individualProject?.title.split("")[0].toUpperCase()}
          </span>
          <span className="flex flex-col justify-center">
            <span
              className="capitalize text-ellipsis overflow-hidden"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {individualProject.title}
            </span>
            <span className="text-sm text-gray-700">
              {individualProject?.createdAt
                ? moment(individualProject?.createdAt).format("DD-MM-YYYY")
                : null}
            </span>
          </span>
        </span>
        <span onClick={(e) => e.stopPropagation()}>
          {varient !== "default" && (
            <Popover
              content={
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    setActive("dashboard");
                    setProjectStatus(true);
                    setProject({
                      id: individualProject?.id,
                      name: individualProject?.title,
                      description: individualProject?.description,
                      accessLevel: individualProject?.access_level,
                    });
                  }}
                >
                  View Details
                </span>
              }
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-6 h-6 text-black"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </Popover>
          )}
        </span>
      </div>
      {individualProject?.description && (
        <div className="mt-5">
          <span>Description:</span>
          <p
            className="text-sm text-gray-700 mt-1 text-ellipsis overflow-hidden"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
            }}
          >
            {individualProject?.description}
          </p>
        </div>
      )}
    </div>
  );
}
